// Contact Us Actions
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const FETCH_ON_SESSION_START = 'FETCH_ON_SESSION_START';
export const FETCH_ON_SESSION_START_EXPERIMENTAL = 'FETCH_ON_SESSION_START_EXPERIMENTAL';
export const FETCH_BACKGROUNDAUTH_URI = 'FETCH_BACKGROUNDAUTH_URI';
export const FETCH_BACKGROUNDAUTH_URI_SUCCESS = 'FETCH_BACKGROUNDAUTH_URI_SUCCESS';
export const FETCH_USERINFO_FOR_CLIENT_SIGNIN = 'FETCH_USERINFO_FOR_CLIENT_SIGNIN';
export const FETCH_USERINFO_NOT_SIGNEDIN = 'FETCH_USERINFO_NOT_SIGNEDIN';
export const FETCH_UWP_AUTHINFO = 'FETCH_UWP_AUTHINFO';
export const FETCH_UWP_AUTHINFO_SUCCESS = 'FETCH_UWP_AUTHINFO_SUCCESS';
export const SIGNING_IN_USER = 'SIGNING_IN_USER';
export const SIGN_IN_USER_INTO_CLIENT = 'SIGN_IN_USER_INTO_CLIENT';
export const SIGN_IN_USER_INTO_CLIENT_AGGREGATOR = 'SIGN_IN_USER_INTO_CLIENT_AGGREGATOR';
export const DISMISS_NOTICE = 'DISMISS_NOTICE';
export const SET_CONTACT_SEARCHED_QUERY_TEXT = 'SET_CONTACT_SEARCHED_QUERY_TEXT';
export const SET_IS_AUTOSUGGEST_CARD_SEARCH = 'SET_IS_AUTOSUGGEST_CARD_SEARCH';
export const SET_IS_AUTOSUGGEST_CARD_SEARCH_V2 = 'SET_IS_AUTOSUGGEST_CARD_SEARCH_V2';
export const SET_RELATED_CORRELATION_IDS = 'SET_RELATED_CORRELATION_IDS';
export const CLEAR_RELATED_CORRELATION_IDS = 'CLEAR_RELATED_CORRELATION_IDS';
export const UPDATE_LICENSES = 'UPDATE_LICENSES';
export const RESET_CONTACT_US_FOCUS = 'RESET_CONTACT_US_FOCUS';

// UITabView Actions
export const UPDATE_UITABVIEWINFO = 'UPDATE_UITABVIEWINFO';
export const POP_UITABVIEWSTACK = 'POP_UITABVIEWSTACK';
export const RESET_PAGE_STACK = 'RESET_PAGE_STACK';

// Self-help AutoSuggest Actions
export const TOGGLE_AUTOSUGGEST = 'TOGGLE_AUTOSUGGEST';
export const FETCH_AUTOSUGGEST = 'FETCH_AUTOSUGGEST';
export const FETCH_AUTOSUGGEST_V2 = 'FETCH_AUTOSUGGEST_V2';
export const SET_AUTOSUGGEST_RESULT = 'SET_AUTOSUGGEST_RESULT';
export const SET_AUTOSUGGEST_RESULT_V2 = 'SET_AUTOSUGGEST_RESULT_V2';
export const SET_AUTOSUGGEST_FOCUSED_INDEX = 'SET_AUTOSUGGEST_FOCUSED_INDEX';
export const SET_ORIGINAL_QUERY = 'SET_ORIGINAL_QUERY';
export const SET_QUERY_CHANGED = 'SET_QUERY_CHANGED';

// Coachmark Action
export const TOGGLE_COACHMARK = 'TOGGLE_COACHMARK'
export const GET_ALCHEMY_THEME_ROUTING_DATA = 'GET_ALCHEMY_THEME_ROUTING_DATA';
export const GET_ALCHEMY_THEME_ROUTING_DATA_SUCCESS = 'GET_ALCHEMY_THEME_ROUTING_DATA_SUCCESS';
export const GET_ALCHEMY_THEME_ROUTING_DATA_ERROR = 'GET_ALCHEMY_THEME_ROUTING_DATA_ERROR';

// Self-Help Alchemy Actions
export const INIT_SELF_HELP_ALCHEMY_ON_SESSION_START = 'INIT_SELF_HELP_ALCHEMY_ON_SESSION_START';
export const FETCH_ALCHEMY_ERROR = 'FETCH_ALCHEMY_ERROR';
export const FETCH_ALCHEMY_SUCCESS = 'FETCH_ALCHEMY_SUCCESS';
export const FETCH_ALCHEMY_SUCCESS_3P = 'FETCH_ALCHEMY_SUCCESS_3P';
export const SUBMIT_ALCHEMY_INSIGHT_FEEDBACK = 'SUBMIT_ALCHEMY_INSIGHT_FEEDBACK';
export const RESET_SEARCH_SESSION = 'RESET_SEARCH_SESSION';
export const SET_EXPANDED_INSIGHT = 'SET_EXPANDED_INSIGHT';
export const UPDATE_DEEPLINK = 'UPDATE_DEEPLINK';
export const TOGGLE_SEE_MORE_INSIGHTS = 'TOGGLE_SEE_MORE_INSIGHTS';

// Self-Help User Notice Actions
export const FETCH_USER_NOTICES = 'FETCH_USER_NOTICES';
export const FETCH_USER_NOTICES_SUCCESS = 'FETCH_USER_NOTICES_SUCCESS';
export const FETCH_USER_NOTICES_ERROR = 'FETCH_USER_NOTICES_ERROR';

// Self-Help Top result actions
export const TOGGLE_CARD_HEIGHT = 'TOGGLE_CARD_HEIGHT';
export const TOGGLE_CONTENT = 'TOGGLE_CONTENT';

// Modality Section Actions
export const INIT_ALCHEMY_UNAUTH_ON_SESSION_START = 'INIT_ALCHEMY_UNAUTH_ON_SESSION_START';
export const FETCH_UNAUTH_SCHEMA_SUCCESS = 'FETCH_UNAUTH_SCHEMA_SUCCESS';
export const FETCH_UNAUTH_SCHEMA_ERROR = 'FETCH_UNAUTH_SCHEMA_ERROR';
export const TOGGLE_UNAUTH_BRANCHING = 'TOGGLE_UNAUTH_BRANCHING';
export const ERROR_ON_SIGN_IN = 'ERROR_ON_SIGN_IN';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';

// Modality Actions V2
export const FETCH_AVAILABLE_MODALITIES_V2 = 'FETCH_AVAILABLE_MODALITIES_V2';
export const FETCH_AVAILABLE_MODALITIES_V2_ERROR = 'FETCH_AVAILABLE_MODALITIES_V2_ERROR';
export const FETCH_AVAILABLE_MODALITIES_V2_SUCCESS = 'FETCH_AVAILABLE_MODALITIES_V2_SUCCESS';
export const FETCH_REGION_INFO = 'FETCH_REGION_INFO';
export const FETCH_REGION_INFO_SUCCESS = 'FETCH_REGION_INFO_SUCCESS';
export const FETCH_REGION_INFO_ERROR = 'FETCH_REGION_INFO_ERROR';
export const UPDATE_PREFERRED_TIMEZONE = 'UPDATE_PREFERRED_TIMEZONE';
export const UPDATE_PREFERRED_LOCALE = 'UPDATE_PREFERRED_LOCALE';

export const FETCH_REDIRECT_LINK_SUCCESS = 'FETCH_REDIRECT_LINK_SUCCESS';
export const SET_AUTHINFO_FOR_TEAMS = 'SET_AUTHINFO_FOR_TEAMS';
export const FETCH_USERINFO = 'FETCH_USERINFO';
export const FETCH_USERINFO_ERROR = 'FETCH_USERINFO_ERROR';
export const FETCH_USERINFO_SUCCESS = 'FETCH_USERINFO_SUCCESS';
export const GET_INFO_CLIENT_TOKEN_RETRIEVAL = 'GET_INFO_CLIENT_TOKEN_RETRIEVAL';
export const GET_INFO_CLIENT_TOKEN_RETRIEVAL_SUCCESS = 'GET_INFO_CLIENT_TOKEN_RETRIEVAL_SUCCESS';
export const HANDLE_GETTING_MODALITIES_COMPLETE = 'HANDLE_GETTING_MODALITIES_COMPLETE';
export const INIT_MODALITY_SECTION_ON_SESSION_START = 'INIT_MODALITY_SECTION_ON_SESSION_START';
export const REDIRECT_FOR_SIGN_IN = 'REDIRECT_FOR_SIGN_IN';
export const SET_IS_USER_SIGNING_INTO_CLIENT_APP = 'SET_IS_USER_SIGNING_INTO_CLIENT_APP';
export const SHOW_MODALITY_EXPERIENCE_IN_IFRAME = 'SHOW_MODALITY_EXPERIENCE_IN_IFRAME';
export const UPDATE_MODALITIES_SECTION_EXPANDO_STATE = 'UPDATE_MODALITIES_SECTION_EXPANDO_STATE';
export const UPDATE_SIGN_IN = 'UPDATE_SIGN_IN';
export const USER_SIGNEDIN_ON_CLIENT_WITH_RESTORED_STATE = 'USER_SIGNEDIN_ON_CLIENT_WITH_RESTORED_STATE';
export const UPDATE_IS_PHONENUMBER_VALID = 'UPDATE_IS_PHONENUMBER_VALID';
export const UPDATE_IS_PHONENUMBER_VALID_FOR_EDIT = 'UPDATE_IS_PHONENUMBER_VALID_FOR_EDIT';
export const UPDATE_IS_EMAIL_VALID = 'UPDATE_IS_EMAIL_VALID';
export const UPDATE_IS_EMAIL_VALID_FOR_EDIT = 'UPDATE_IS_EMAIL_VALID_FOR_EDIT';
export const UPDATE_IS_TITLE_VALID = 'UPDATE_IS_TITLE_VALID';
export const UPDATE_DRAFT_REQUEST = 'UPDATE_DRAFT_REQUEST';
export const UPDATE_DIALOG_ID = 'UPDATE_DIALOG_ID';
export const HANDLE_THEME_ROUTING = 'HANDLE_THEME_ROUTING';
export const UPDATE_DIRTY_REQUEST = 'UPDATE_DIRTY_REQUEST';
export const SET_DIRTY_REQUEST = 'SET_DIRTY_REQUEST';
export const CREATE_REQUEST = 'CREATE_REQUEST';
export const CREATE_REQUEST_SUCCESS = 'CREATE_REQUEST_SUCCESS';
export const CREATE_REQUEST_ERROR = 'CREATE_REQUEST_ERROR';
export const UPDATE_LAST_OPENED_RAVE_CHAT_REQUEST_CORRELATIONID = 'UPDATE_LAST_OPENED_RAVE_CHAT_REQUEST_CORRELATIONID';
export const UPDATE_BUSINESS_IMPACT_CONFIRMED = 'UPDATE_BUSINESS_IMPACT_CONFIRMED';
export const UPDATE_CUSTOMER_AVAILABILITY_CONFIRMED = 'UPDATE_CUSTOMER_AVAILABILITY_CONFIRMED';
export const UPDATE_BUSINESS_IMPACT_CONFIRMED_FOR_EDIT = 'UPDATE_BUSINESS_IMPACT_CONFIRMED_FOR_EDIT';
export const UPDATE_CUSTOMER_AVAILABILITY_CONFIRMED_FOR_EDIT = 'UPDATE_CUSTOMER_AVAILABILITY_CONFIRMED_FOR_EDIT';
export const UPDATE_SHOW_AGENT_MODALITIES_BUTTON = 'UPDATE_SHOW_AGENT_MODALITIES_BUTTON';
export const UPDATE_SELECTED_EDU_PRODUCT = 'UPDATE_SELECTED_EDU_PRODUCT';

// Attachment Actions
export const ADD_ATTACHMENT = 'ADD_ATTACHMENT';
export const GET_ATTACHMENT_UPLOAD_TOKEN = 'GET_ATTACHMENT_UPLOAD_TOKEN';
export const GET_ATTACHMENT_UPLOAD_TOKEN_SUCCESS = 'GET_ATTACHMENT_UPLOAD_TOKEN_SUCCESS';
export const GET_ATTACHMENT_UPLOAD_TOKEN_ERROR = 'GET_ATTACHMENT_UPLOAD_TOKEN_ERROR';
export const UPLOAD_FILE_METADATA_SUCCESS = 'UPLOAD_FILE_METADATA_SUCCESS';
export const UPLOAD_FILE_METADATA_ERROR = 'UPLOAD_FILE_METADATA_ERROR';
export const UPLOAD_FILE_CHUNK_ERROR = 'UPLOAD_FILE_CHUNK_ERROR';
export const UPLOAD_ATTACHMENT_SUCCESS = 'UPLOAD_ATTACHMENT_SUCCESS';
export const SET_ATTACHMENT_ERROR = 'SET_ATTACHMENT_ERROR';
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT';
export const CANCEL_UPLOAD_ATTACHMENT = 'CANCEL_UPLOAD_ATTACHMENT';
export const SAVE_ATTACHMENT_API_CANCEL_TOKEN_ID = 'SAVE_ATTACHMENT_API_CANCEL_TOKEN_ID';
export const FLUSH_ATTACHMENT_API_CANCEL_TOKEN_IDS = 'FLUSH_ATTACHMENT_API_CANCEL_TOKEN_IDS';
export const ATTACHMENT_ACTION_COMPLETED_ACTION = 'ATTACHMENT_ACTION_COMPLETED_ACTION';
export const ATTACHMENT_ACTION_ABORTED_ACTION = 'ATTACHMENT_ACTION_ABORTED_ACTION';
export const GET_ATTACHMENT_DOWNLOAD_TOKEN = 'GET_ATTACHMENT_DOWNLOAD_TOKEN';
export const GET_ATTACHMENT_DOWNLOAD_TOKEN_SUCCESS = 'GET_ATTACHMENT_DOWNLOAD_TOKEN_SUCCESS';
export const GET_ATTACHMENT_DOWNLOAD_TOKEN_ERROR = 'GET_ATTACHMENT_DOWNLOAD_TOKEN_ERROR';
export const UPDATE_DRAFTREQUEST_WORKSPACE_ID = 'UPDATE_DRAFTREQUEST_WORKSPACE_ID';

// App/Search Actions
export const ADD_TO_HISTORY = 'ADD_TO_HISTORY';
export const CONTACT_ARTICLE_CLICKED = 'CONTACT_ARTICLE_CLICKED';
export const DISABLE_BACK_BUTTON = 'DISABLE_BACK_BUTTON';
export const FETCH_CSRF_FORM_TOKEN = 'FETCH_CSRF_FORM_TOKEN';
export const FETCH_CSRF_FORM_TOKEN_ERROR = 'FETCH_CSRF_FORM_TOKEN_ERROR';
export const FETCH_CSRF_FORM_TOKEN_SUCCESS = 'FETCH_CSRF_FORM_TOKEN_SUCCESS';
export const NO_UPDATE_FOR_NS_AND_VERSION_COOKIES_FOR_AGAVE_PANE = 'NO_UPDATE_FOR_NS_AND_VERSION_COOKIES_FOR_AGAVE_PANE';
export const POP_HISTORY = 'POP_HISTORY';
export const SAVE_MODALITIES = 'SAVE_MODALITIES';
export const SET_DISPLAY_NAMESPACE = 'SET_DISPLAY_NAMESPACE';
export const SET_INITIALIZATION_COMPLETE = 'SET_INITIALIZATION_COMPLETE';
export const SET_NAVBAR_SETTINGS = 'SET_NAVBAR_SETTINGS';
export const UPDATE_NS_AND_VERSION_COOKIES_FOR_AGAVE_PANE = 'UPDATE_NS_AND_VERSION_COOKIES_FOR_AGAVE_PANE';
export const SET_SESSION_DATA = 'SET_SESSION_DATA';
export const HIDE_REQUEST_CREATION_TAB = 'HIDE_REQUEST_CREATION_TAB';

// Initialization Actions
export const SET_THEME = 'SET_THEME';
export const UPDATE_THEME = 'UPDATE_THEME';
export const UPDATE_COLOR = 'UPDATE_COLOR';
export const SET_MARKET = 'SET_MARKET';
export const GET_EMERALD_CONFIG = 'GET_EMERALD_CONFIG';
export const GET_EMERALD_CONFIG_ERROR = 'GET_EMERALD_CONFIG_ERROR';
export const GET_EMERALD_CONFIG_SUCCESS = 'GET_EMERALD_CONFIG_SUCCESS';
export const GET_EMERALD_SUPPORTCONFIG = 'GET_EMERALD_SUPPORTCONFIG';
export const GET_EMERALD_SUPPORTCONFIG_ERROR = 'GET_EMERALD_SUPPORTCONFIG_ERROR';
export const GET_EMERALD_SUPPORTCONFIG_SUCCESS = 'GET_EMERALD_SUPPORTCONFIG_SUCCESS';
export const UPDATE_GETHELP_CONFIG = 'UPDATE_GETHELP_CONFIG';
export const UPDATE_ECS_CONFIGURATION = 'UPDATE_ECS_CONFIGURATION';

// Teams related actions
export const INITIALIZE_TEAMS_SDK = 'INITIALIZE_TEAMS_SDK';
export const TEAMS_SDK_CONTEXT_NOTIFICATION = 'TEAMS_SDK_CONTEXT_NOTIFICATION';

// Request History actions
export const SEARCH_REQUESTS = 'SEARCH_REQUESTS';
export const SEARCH_REQUESTS_SUCCESS = 'SEARCH_REQUESTS_SUCCESS';
export const SEARCH_REQUESTS_ERROR = 'SEARCH_REQUESTS_ERROR';
export const GET_REQUEST = 'GET_REQUEST';
export const GET_REQUEST_SUCCESS = 'GET_REQUEST_SUCCESS';
export const GET_REQUEST_ERROR = 'GET_REQUEST_ERROR';
export const UPDATE_CONTACTS = 'UPDATE_CONTACTS';
export const UPDATE_CONTACTS_SUCCESS = 'UPDATE_CONTACTS_SUCCESS';
export const UPDATE_CONTACTS_ERROR = 'UPDATE_CONTACTS_ERROR';
export const UPDATE_ATTACHMENTS = 'UPDATE_ATTACHMENTS';
export const UPDATE_ATTACHMENTS_SUCCESS = 'UPDATE_ATTACHMENTS_SUCCESS';
export const UPDATE_ATTACHMENTS_ERROR = 'UPDATE_ATTACHMENTS_ERROR';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const ADD_NOTE = 'ADD_NOTE';
export const ADD_NOTE_SUCCESS = 'ADD_NOTE_SUCCESS';
export const ADD_NOTE_ERROR = 'ADD_NOTE_ERROR';
export const RESET_REQUEST_DETAILS_EDIT_ERROR = 'RESET_REQUEST_DETAILS_EDIT_ERROR';

// Outdated Devices Alert actions
export const DISMISS_OUTDATED_DEVICES_ALERT = 'DISMISS_OUTDATED_DEVICES_ALERT';
export const TOGGLE_OUTDATED_DEVICES_ALERT_EXPAND = 'TOGGLE_OUTDATED_DEVICES_ALERT_EXPAND';

// VSB Upsell Alert actions
export const DISMISS_VSB_UPSELL_ALERT = 'DISMISS_VSB_UPSELL_ALERT';
export const SET_CTA_CLICKED_VSB_UPSELL_ALERT = 'SET_CTA_CLICKED_VSB_UPSELL_ALERT';
export const SET_VSB_UPSELL_ALERT_ACTIVATED = 'SET_VSB_UPSELL_ALERT_ACTIVATED';

export const SET_ISINITIALIZED_OCV = 'SET_INITIALIZED_OCV';

// Request Feedback actions
export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_ERROR = 'SUBMIT_FEEDBACK_ERROR';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const RESET_FEEDBACK = 'RESET_FEEDBACK';

export const DIAGNOSTIC_RUN_START = 'DIAGNOSTIC_RUN_START';
export const DIAGNOSTIC_RUN_COMPLETE = 'DIAGNOSTIC_RUN_COMPLETE';
export const DIAGNOSTIC_RUN_ERROR = 'DIAGNOSTIC_RUN_ERROR';
export const DIAGNOSTIC_RUN_TIMEOUT = 'DIAGNOSTIC_RUN_TIMEOUT';

export const SET_STARTUP_DIAG_STATUS = 'SET_STARTUP_DIAG_STATUS';

// ServiceRequest pagination actions
export const PUSH_PAGE_STACK = 'PUSH_PAGE_STACK';
export const POP_PAGE_STACK = 'POP_PAGE_STACK';
export const INITIALIZE_PAGE_STACK = 'INITIALIZE_PAGE_STACK';
export const EMPTY_PAGE_STACK = 'EMPTY_PAGE_STACK';

// WindowsUpdate Action for Surface App
export const SHOW_WINDOWS_UPDATE_AVAILABLE_FOR_SA = "SHOW_WINDOWS_UPDATE_AVAILABLE_FOR_SA";
export const DISMISS_WINDOWS_UPDATE_AVAILABLE_FOR_SA = "DISMISS_WINDOWS_UPDATE_AVAILABLE_FOR_SA";

// EndOfLifeSupport Action for Surface App
export const SHOW_END_OF_LIFE_MESSAGE_FOR_SA = "SHOW_END_OF_LIFE_MESSAGE_FOR_SA";
export const DISMISS_END_OF_LIFE_MESSAGE_FOR_SA = "DISMISS_END_OF_LIFE_MESSAGE_FOR_SA";

// EndOfServiceSupport Action for Win 10 in Surface App
export const SHOW_END_OF_SERVICE_MESSAGE_FOR_WIN10_SA = "SHOW_END_OF_SERVICE_MESSAGE_FOR_WIN10_SA";
export const DISMISS_END_OF_SERVICE_MESSAGE_FOR_WIN10_SA = "DISMISS_END_OF_SERVICE_MESSAGE_FOR_WIN10_SA";
